import {Injectable} from '@angular/core';
import {FormGroup} from "@angular/forms";
import {HttpService} from "../../../shared/services/http.service";

@Injectable({
  providedIn: 'root'
})
export class IdSchemeService {

  constructor(private httpClient: HttpService) {
  }

  /**
   * Récupére le path de tous les objets qui doivent etre verifié car ils contiennent un id scheme et sont potentiellement vides par type de formulaire
   * Et parcours le formulaire jusqu'à ces objets
   * @param form
   * @param formulaireName
   */
  async checkIfSchemeIdHaveToBeDeleted(form: FormGroup, formulaireName: string): Promise<FormGroup> {
    let pathsToVerify = [];
    const path = 'assets/dynamic/creer/formSections/' + formulaireName + '.json';
    const formId: string = formulaireName.replace('E_FORM_', '');
    return new Promise((resolve, reject) => {
      this.httpClient.get(path, null, {basePath: ''}).subscribe(content => {
        this.findOptionalUseOfSchemeId(content, formId, pathsToVerify);
        resolve(this.goToObjetsToVerify(form, pathsToVerify));
      });
    });
  }


  /**
   *On vérifie chaque niveau du formulaire recursivement pour trouver le ou les paths d'objet(s) à vérifier qui ont un schemeId mais ne sont pas obligatoire pour ce formulaire
   * @param objectToVerify
   * @param formId
   * @param pathsToVerify
   * @private
   */
  private findOptionalUseOfSchemeId(objectToVerify, formId, pathsToVerify) {
    //S'il a un schemeId, on vérifie si c'est obligatoire ou pas (on veut contrôler le remplissage des objets optionnels qui sont potentiellement préremplis à tort)
    if (objectToVerify._idScheme && objectToVerify.pattern && (!objectToVerify.mandatory || (objectToVerify.mandatory && !objectToVerify.mandatory.includes(formId)))) {
      const pathToVerify = objectToVerify.jsonPath.slice(0, objectToVerify.jsonPath.lastIndexOf('[]') + 2);
      pathsToVerify.push({path:pathToVerify,schemeId:objectToVerify._idScheme});
    }
    if (objectToVerify.content) {
      objectToVerify.content.forEach(content => {
        this.findOptionalUseOfSchemeId(content, formId, pathsToVerify)
      });
    }
  }

  /**
   * On descend jusqy'aux objets à vérifier
   * @param form
   * @param objetToVerifyPaths
   * @private
   */
  private goToObjetsToVerify(form: FormGroup, objetToVerifyPaths) {
    objetToVerifyPaths.forEach(data => {
      let jsonPath = 'eforms.' + data.path;
      this.findObjectByJsonPath(jsonPath, form, data.schemeId);
    });
    return form;
  }

  /**
   * Cherche récursivement une liste d'objets désignés par un jsonPath pour ensuite lancer leur analyse
   * et supprimer ceux qui sont vides
   * @param jsonPath
   * @param actualItem
   * @private
   */
  private findObjectByJsonPath(jsonPath, actualItem, schemeId) {
    const firstPathElement = jsonPath.split('.')[0];
    const updatedFirstElement = firstPathElement.replace('[]', '');
    if (jsonPath === '') {
      actualItem.controls.forEach((item, index) => {
        if (this.haveToCleanObject(item,schemeId)) {
          //Suppression de l'iteration vide
          actualItem.controls.splice(index, 1);
        }
      });
    } else if (Array.isArray(actualItem.controls)) {
      const newJsonPath = jsonPath.includes('.') ? jsonPath.replace(firstPathElement + '.', '') : '';
      actualItem.controls.forEach((item, index) => {
        const newActualItem = actualItem.controls[index].controls[updatedFirstElement];
        if(newActualItem){
          this.findObjectByJsonPath(newJsonPath, newActualItem, schemeId);
        }
      });
    } else {
      const newActualItem = actualItem.controls[updatedFirstElement];
      const newJsonPath = jsonPath.includes('.') ? jsonPath.replace(firstPathElement + '.', '') : '';
      if(newActualItem){
        this.findObjectByJsonPath(newJsonPath, newActualItem, schemeId);
      }
    }
  }

  /**
   * On parcourt tous les sous-objets, on compte les "val" remplies
   * Si on a au moins une "val" autre que le schemeId de remplie, on ne fait rien (return false)
   * Sinon on supprime l'objet (return true)
   * @param actualItem
   * @private
   */
  private haveToCleanObject(actualItem,schemeId) {
    return this.checkItemLevel(actualItem,schemeId,0) === 1;
  }

  /**
   * Vérifie recursivement chaque niveau d'objet
   * @param item
   * @param count
   * @private
   */
  private checkItemLevel(item, schemeId, count) {
    if (item.controls !== undefined && item.controls['val']) {
      if (item.controls['val'].value) {
        count++;
        //si le schemeId ne correspond pas a celui recherché, on ajoute +2 pour que l'objet reste inchangé
        if(!String(item.controls['val'].value).includes(schemeId)){
          count++;
        }
      }
    } else if(item.controls === undefined && item.value && !String(item.value).includes(schemeId)){
      count ++;
    } else if (Array.isArray(item.controls)) {
      item.controls.forEach(item => {
        Object.keys(item.controls).forEach(key => {
          if(key!=='inputId'){
            count += this.checkItemLevel(item.controls[key], schemeId, 0);
          }
        });
      });
    } else if (item.controls) {
      Object.keys(item.controls).forEach(key => {
        if(key!=='inputId'){
          count += this.checkItemLevel(item.controls[key], schemeId,0);
        }
      });
    }
    return count;
  }
}

